export default "__VITE_ASSET__B7$eG2JW__"